// The ticket contains no artwork in the URL. Its short-lived bearer token is
// carried in the fragment so it is excluded from server logs and referrers.
(async function restoreReorder() {
  const token = new URLSearchParams(location.hash.slice(1)).get('spark-reorder');
  if (!token || !/^[a-f0-9]{64}$/.test(token)) return;
  const main = document.querySelector('main') || document.body;
  const status = document.createElement('div');
  status.setAttribute('role', 'status');
  status.style.cssText = 'padding:16px;margin:16px;border:1px solid #ffccb5;border-radius:10px;background:#fff8f3;color:#101b31';
  status.textContent = 'Restoring your previous artwork and options…';
  main.prepend(status);
  const root = window.Shopify?.routes?.root || '/';
  async function json(url, options) {
    const response = await fetch(url, options);
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || data.description || 'Could not restore your order.');
    return data;
  }
  async function restore() {
    try {
      const { items } = await json('https://configurator.sparkstickers.com/api/proofs/reorders/redeem', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: '{}' });
      const cart = await json(root + 'cart.js');
      const missing = items.filter(item => !cart.items.some(existing =>
        existing.properties?._Reorder_attempt === token && existing.properties?._Reorder_source_line === item.properties._Reorder_source_line));
      if (missing.length) await json(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: missing }) });
      const updated = await json(root + 'cart.js');
      if (!items.every(item => updated.items.some(existing => existing.properties?._Reorder_attempt === token
        && existing.properties?._Reorder_source_line === item.properties._Reorder_source_line
        && existing.properties?.['_Artwork manifest'] === item.properties['_Artwork manifest']))) {
        throw new Error('Please check your cart, then retry restoring this order.');
      }
      history.replaceState(null, '', location.pathname + location.search);
      location.reload();
    } catch (error) {
      status.textContent = error.message + ' ';
      const retry = document.createElement('button');
      retry.type = 'button'; retry.textContent = 'Retry';
      retry.addEventListener('click', () => { retry.disabled = true; runRestore(); }, { once: true });
      status.append(retry);
    }
  }
  // Serializes restores across tabs where supported and prevents duplicate adds.
  async function runRestore() {
    if (navigator.locks) return navigator.locks.request('spark-reorder-' + token, restore);
    return restore();
  }
  await runRestore();
})();
